<template>
  <div class="mt-3 pb-4 mb-4 font-jumper">
    <b-container
      fluid
      id="employee-holiday-container"
      class="employee-holiday pt-4 col-12"
    >
      <b-row>
        <b-col class="ml-0 profile-input-container" cols="12">
          <div class="employee-layout">
            <section
              class="employee-section-card"
              aria-label="Új szabadság rögzítése"
            >
              <header class="employee-section-header">
                <h2
                  id="new-holiday-heading"
                  class="employee-section-title d-none d-md-block"
                >
                  Új szabadság rögzítése
                </h2>
                <button
                  type="button"
                  class="employee-section-toggle d-md-none"
                  aria-controls="new-holiday-panel"
                  :aria-expanded="String(newHolidayOpen)"
                  @click="newHolidayOpen = !newHolidayOpen"
                >
                  <span>Új szabadság rögzítése</span>
                  <b-icon
                    :icon="newHolidayOpen ? 'chevron-up' : 'chevron-down'"
                    aria-hidden="true"
                  ></b-icon>
                </button>
              </header>

              <b-collapse
                id="new-holiday-panel"
                v-model="newHolidayOpen"
                class="employee-section-body"
              >
                <div class="employee-fields-grid">
                  <div class="data-wrapper">
                    <label
                      class="employee-field-label employee-field-title"
                      for="employee-holiday-start"
                    >
                      Szabadság kezdete
                    </label>
                    <DatePicker
                      id="employee-holiday-start"
                      v-model="newHoliday.startDate"
                      format="YYYY-MM-DD"
                      value-type="format"
                      class="employee-date-picker white-input"
                      aria-label="Szabadság kezdete"
                    />
                  </div>

                  <div class="data-wrapper">
                    <label
                      class="employee-field-label employee-field-title"
                      for="employee-holiday-end"
                    >
                      Szabadság vége
                    </label>
                    <DatePicker
                      id="employee-holiday-end"
                      v-model="newHoliday.endDate"
                      format="YYYY-MM-DD"
                      value-type="format"
                      class="employee-date-picker white-input"
                      aria-label="Szabadság vége"
                    />
                  </div>

                  <div class="employee-field-full employee-form-actions">
                    <BaseButton
                      variant="success"
                      label="Rögzítés"
                      @click="saveNewHoliday"
                    />
                  </div>
                </div>
              </b-collapse>
            </section>

            <section
              v-if="holidays.length"
              class="employee-section-card"
              aria-label="Rögzített szabadságok"
            >
              <header class="employee-section-header">
                <h2
                  id="saved-holidays-heading"
                  class="employee-section-title d-none d-md-block"
                >
                  Rögzített szabadságok
                </h2>
                <button
                  type="button"
                  class="employee-section-toggle d-md-none"
                  aria-controls="saved-holidays-panel"
                  :aria-expanded="String(savedHolidaysOpen)"
                  @click="savedHolidaysOpen = !savedHolidaysOpen"
                >
                  <span>Rögzített szabadságok</span>
                  <b-icon
                    :icon="savedHolidaysOpen ? 'chevron-up' : 'chevron-down'"
                    aria-hidden="true"
                  ></b-icon>
                </button>
              </header>

              <b-collapse
                id="saved-holidays-panel"
                v-model="savedHolidaysOpen"
                class="employee-section-body"
              >
                <div class="employee-table-wrapper">
                  <b-table
                    class="employee-table"
                    responsive
                    striped
                    hover
                    :items="holidays"
                    :fields="config.tableFields"
                  >
                    <template #cell(id)="data">
                      <BaseButton
                        variant="light"
                        size="sm"
                        icon="trash"
                        icon-only
                        aria-label="Törlés"
                        @click="() => deleteHoliday(data.item.id)"
                      />
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </section>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Api from "@/api/server/index";
import BaseButton from "@/components/BaseButton.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/hu";

export default {
  name: "EmployeeHoliday",

  components: { BaseButton, DatePicker },

  props: {
    employeeId: Number,
  },

  data() {
    return {
      config: {
        tableFields: [
          {
            key: 'startDate',
            label: 'Kezdő dátum'
          },
          {
            key: 'endDate',
            label: 'Vég dátum'
          },
          {
            key: 'id',
            label: 'Törlés'
          }
        ]
      },

      newHolidayOpen: !this.isMobile(),
      savedHolidaysOpen: !this.isMobile(),

      holidays: [],
      newHoliday: {
        employeeId: this.employeeId
      }
    };
  },

  mounted() {
    this.loadHolidays();
  },

  methods: {
    isMobile() {
      return window.innerWidth <= 768;
    },

    loadHolidays() {
      Api.holidaysByEmployee(this.employeeId).then(
          (resp) => (this.holidays = resp.data)
      );
    },

    resetNewHoliday() {
      this.newHoliday = {
        employeeId: this.employeeId
      };
    },

    async saveNewHoliday() {
      await Api.saveHoliday(this.newHoliday);
      this.resetNewHoliday();
      this.loadHolidays();
    },

    async deleteHoliday(id) {
      await Api.deleteHoliday(id);
      this.loadHolidays();
    }
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.hidden {
  display: none !important;
}

#employee-holiday-container.employee-holiday {
  color: #252734;
  padding-left: 0;
  padding-right: 0;
}

.employee-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.employee-section-card {
  border: 1px solid #AEBFC7;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.74);
  box-shadow: 0 20px 40px rgba(37, 39, 52, 0.08);
  padding: 28px;
}

.employee-section-header {
  margin-bottom: 18px;
}

.employee-section-title {
  color: #252734;
  font-family: JumperBold;
  font-size: 24px;
  line-height: 1.2;
  margin: 0;
}

.employee-section-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #252734;
  display: flex;
  font-family: JumperBold;
  font-size: 22px;
  justify-content: space-between;
  padding: 0;
  text-align: left;
  width: 100%;
}

.employee-section-toggle:focus {
  border-radius: 16px;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.7);
  outline: none;
}

.employee-fields-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 20px;
}

.employee-field-full {
  grid-column: 1 / -1;
}

.data-wrapper {
  min-height: auto;
}

.employee-field-title {
  color: #252734;
  display: block;
  font-family: JumperBold;
  font-size: 12px;
  line-height: 1.25;
  margin: 0 0 8px !important;
  padding-left: 20px;
}

.employee-form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 18px;
}

.employee-table-wrapper {
  border-radius: 24px;
  overflow: hidden;
}

#employee-holiday-container.employee-holiday input,
#employee-holiday-container.employee-holiday select,
#employee-holiday-container.employee-holiday .custom-select {
  background: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 32px !important;
  box-shadow: 0 10px 24px rgba(37, 39, 52, 0.09) !important;
  color: #252734 !important;
  font-family: Poppins, sans-serif !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  min-height: 42px;
  width: 100% !important;
}

#employee-holiday-container.employee-holiday input::placeholder,
#employee-holiday-container.employee-holiday select option {
  font-family: Poppins, sans-serif !important;
  font-weight: 400 !important;
}

#employee-holiday-container.employee-holiday input:focus,
#employee-holiday-container.employee-holiday select:focus,
#employee-holiday-container.employee-holiday .custom-select:focus-within {
  border-color: #5bb65d !important;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.35), 0 10px 24px rgba(37, 39, 52, 0.09) !important;
  outline: none;
}

#employee-holiday-container.employee-holiday .row {
  margin-left: -8px;
  margin-right: -8px;
}

#employee-holiday-container.employee-holiday .row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

#employee-holiday-container.employee-holiday .btn-light {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 999px !important;
  box-shadow: 0 8px 18px rgba(37, 39, 52, 0.08);
  display: inline-flex;
  justify-content: center;
  min-height: 38px;
}

#employee-holiday-container.employee-holiday .text-danger {
  color: #9f1d1d !important;
  font-size: 12px;
}

.employee-table-wrapper ::v-deep table {
  margin-bottom: 0;
}

.employee-table-wrapper ::v-deep thead th {
  border-bottom: 1px solid #AEBFC7;
  border-top: 0;
  color: #252734;
  font-family: JumperBold;
  font-size: 12px;
  line-height: 1.25;
  vertical-align: middle;
}

.employee-table-wrapper ::v-deep tbody td {
  border-top: 0;
  color: #252734;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  vertical-align: middle;
}

.employee-table-wrapper ::v-deep tbody tr:not(:last-child) td {
  border-bottom: 1px solid rgba(174, 191, 199, 0.45);
}

.employee-table-wrapper ::v-deep tbody tr.table-striped,
.employee-table-wrapper ::v-deep tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.55);
}

@media (min-width: 769px) {
  .employee-section-body.collapse:not(.show) {
    display: block !important;
    height: auto !important;
    visibility: visible !important;
  }
}

@media (max-width: 768px) {
  #employee-holiday-container.employee-holiday {
    padding-top: 16px !important;
  }

  .employee-layout,
  .employee-fields-grid {
    grid-template-columns: 1fr;
  }

  .employee-layout {
    gap: 16px;
  }

  .employee-section-card {
    border-radius: 28px;
    padding: 20px;
  }

  .employee-form-actions {
    justify-content: flex-start;
  }
}
</style>
